import { useEffect, useState } from "react";
import { http, API } from "./api";

export const imgSrc = (url) => (url?.startsWith("/api/") ? `${API.replace(/\/api$/, "")}${url}` : url || "/images/box-white.jpg");

let cache = null;

export const useProducts = () => {
  const [products, setProducts] = useState(cache ?? []);
  useEffect(() => {
    let alive = true;
    http.get("/products")
      .then((r) => {
        cache = Array.isArray(r.data) ? r.data : [];
        if (alive) setProducts(cache);
      })
      .catch(() => {});
    return () => { alive = false; };
  }, []);
  return products;
};

export const itemsLabel = (o) =>
  Array.isArray(o?.items) && o.items.length
    ? o.items.map((i) => `${i.quantity} × ${i.name}${i.note ? ` (${i.note})` : ""}`)
    : [`${o?.quantity ?? 0} × box`];
